import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateEmployeeSearch = () => {
  const corporateEmployeeSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/employee/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateEmployeeSearch }
}

export default InteractorCorporateEmployeeSearch
